import { useQuery } from '@tanstack/react-query';
import { getSystemTables } from '../services/ApiService';
import { SystemTablesResponse } from '../models/SystemTables'; 

export const useSystemTables = () => {
  return useQuery<SystemTablesResponse>({
    queryKey: ['systemTables'],  // Unique key for caching 
    queryFn: getSystemTables,    // The fetch function
    staleTime: 1000 * 60 * 30,    // Optional: data considered fresh for 30 minutes
  });
};